<template>
  <div class="flex items-center grid-gap-8">
    <img
      :src="`${ASSETS_CDN}/icons/checked-green-nobackground.svg`"
      width="16"
      height="16"
      alt=""
    />

    <label class="fs-16 lh-24"> {{ label }} </label>
  </div>
</template>

<script setup>
import {assetCDN} from '~/helper/index.js'

defineProps({
  label: {
    type: String,
    default: ''
  }
})
const ASSETS_CDN = assetCDN()
</script>

<style lang="scss" scoped></style>
